import i18n from '../i18n';

const variants = [
  {
    tabText: i18n.t('constants.variants.central.title'),
    title: i18n.t('constants.variants.selectMicro'),
    checkboxes: {
      1: i18n.t('constants.variants.central.checkboxes.1'),
      2: i18n.t('constants.variants.central.checkboxes.2'),
      3: i18n.t('constants.variants.central.checkboxes.3'),
      4: i18n.t('constants.variants.central.checkboxes.4'),
      5: i18n.t('constants.variants.central.checkboxes.5'),
      6: i18n.t('constants.variants.central.checkboxes.6'),
      7: i18n.t('constants.variants.central.checkboxes.7'),
      8: i18n.t('constants.variants.central.checkboxes.8'),
      9: i18n.t('constants.variants.central.checkboxes.9'),
      10: i18n.t('constants.variants.central.checkboxes.10')
    }
  },
  {
    tabText: i18n.t('constants.variants.hostinskii.title'),
    title: i18n.t('constants.variants.selectMicro'),
    checkboxes: {
      11: i18n.t('constants.variants.hostinskii.checkboxes.11'),
      12: i18n.t('constants.variants.hostinskii.checkboxes.12'),
      13: i18n.t('constants.variants.hostinskii.checkboxes.13'),
      14: i18n.t('constants.variants.hostinskii.checkboxes.14'),
      15: i18n.t('constants.variants.hostinskii.checkboxes.15'),
      16: i18n.t('constants.variants.hostinskii.checkboxes.16'),
      18: i18n.t('constants.variants.hostinskii.checkboxes.17'),
      17: i18n.t('constants.variants.hostinskii.checkboxes.18'),
      19: i18n.t('constants.variants.hostinskii.checkboxes.19'),
      20: i18n.t('constants.variants.hostinskii.checkboxes.20'),
      21: i18n.t('constants.variants.hostinskii.checkboxes.21'),
      22: i18n.t('constants.variants.hostinskii.checkboxes.22')
    }
  },
  {
    tabText: i18n.t('constants.variants.adler.title'),
    title: i18n.t('constants.variants.selectMicro'),
    checkboxes: {
      23: i18n.t('constants.variants.adler.checkboxes.23'),
      24: i18n.t('constants.variants.adler.checkboxes.24'),
      25: i18n.t('constants.variants.adler.checkboxes.25'),
      26: i18n.t('constants.variants.adler.checkboxes.26'),
      27: i18n.t('constants.variants.adler.checkboxes.27'),
      28: i18n.t('constants.variants.adler.checkboxes.28'),
      29: i18n.t('constants.variants.adler.checkboxes.29'),
      30: i18n.t('constants.variants.adler.checkboxes.30'),
      31: i18n.t('constants.variants.adler.checkboxes.31'),
      32: i18n.t('constants.variants.adler.checkboxes.32'),
      33: i18n.t('constants.variants.adler.checkboxes.33')
    }
  },
  {
    tabText: i18n.t('constants.variants.lazar.title'),
    title: i18n.t('constants.variants.selectMicro'),
    checkboxes: {
      34: i18n.t('constants.variants.lazar.checkboxes.34'),
      35: i18n.t('constants.variants.lazar.checkboxes.35'),
      36: i18n.t('constants.variants.lazar.checkboxes.36')
    }
  },
  {
    tabText: i18n.t('constants.variants.tuapse.title'),
    title: i18n.t('constants.variants.selectMicro'),
    checkboxes: {
      37: i18n.t('constants.variants.tuapse.checkboxes.37')
    }
  }
];

export default variants;



// WEBPACK FOOTER //
// ./src/constants/Districts.js